import { useContext } from 'react';
import clsx from 'clsx';

import WorkTemplateCreationModalContext, {
  EMPTY_SCHEMA,
} from '@atom/components/common/workTemplateCreationModal/WorkTemplateCreationModalContext';
import { usePreferences } from '@atom/hooks/usePreferences';
import { useSchemas } from '@atom/hooks/useSchemas';
import { Icon, Select } from '@atom/mui';
import { CategoryIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { InventorySchemaItem } from '@atom/types/schema';
import { TYPE_OPTIONS, WorkOrderType } from '@atom/types/work';
import schemaUtilities from '@atom/utilities/schemaUtilities';

import RadioButtonRow from './RadioButtonRow';

import classes from './workTemplateCreationModal.module.css';

const { MenuItem } = Select;

const styles = {
  textFieldStyle: {
    marginLeft: '1rem',
    color: colors.neutral.dark,
  },
  icon: {
    marginTop: '1rem',
  },
};

const TemplateTypeView = () => {
  const { schemas = [] } = useSchemas();
  const preferences = usePreferences();
  const multiLocationEnabled = preferences?.workOrders?.multiLocationEnabled;

  const { type, setType, schemaId, setSchemaId } = useContext(
    WorkTemplateCreationModalContext,
  );

  return (
    <>
      <div className={clsx(classes.modalRow, classes.title)}>Template Type</div>
      {multiLocationEnabled && (
        <RadioButtonRow
          option={TYPE_OPTIONS[WorkOrderType.TASK_ASSETS_AND_LOCATIONS]}
          selected={type === WorkOrderType.TASK_ASSETS_AND_LOCATIONS}
          onClick={setType}
        />
      )}
      <RadioButtonRow
        option={TYPE_OPTIONS[WorkOrderType.DEFAULT]}
        selected={type === WorkOrderType.DEFAULT}
        onClick={setType}
      />
      {type === WorkOrderType.DEFAULT && (
        <div className={classes.modalRow}>
          <Icon
            color={colors.neutral.gray}
            style={styles.icon}
            icon={CategoryIcon}
          />
          <Select
            value={schemaId}
            style={styles.textFieldStyle}
            onChange={event => setSchemaId(String(event.target.value))}
            label="Asset Type"
            fullWidth
          >
            <MenuItem key="empty" value={EMPTY_SCHEMA}>
              <div className={classes.schemaMenuItemContainer}>
                <div className={classes.emptyIcon}>-</div>
                <div
                  className={clsx(classes.schemaMenuItemTitle, classes.empty)}
                >
                  All Asset Types
                </div>
              </div>
            </MenuItem>
            {schemas.map((schema: InventorySchemaItem) => {
              const icon =
                schemaUtilities.getSchemaIconFromSchemaOrAsset(schema);

              return (
                <MenuItem key={schema.id} value={schema.id}>
                  <div className={classes.schemaMenuItemContainer}>
                    {icon}
                    <div className={classes.schemaMenuItemTitle}>
                      {schema.name}
                    </div>
                  </div>
                </MenuItem>
              );
            })}
          </Select>
        </div>
      )}
    </>
  );
};

export default TemplateTypeView;
